// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/background_title.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-header[data-v-c7631b96]{background-color:#fafafa;background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");background-size:65%;width:100%;height:56px;padding-left:70px;margin-right:70px;padding-top:10px;display:block;color:#00475a;position:fixed;Z-index:10;text-transform:uppercase}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
